import { composeExport } from '@/formily/__builtins__/shared'
import { connect, h, mapProps, mapReadPretty } from '@formily/vue'
import { defineComponent } from 'vue-demi'
import { SelectPreviewText } from '../PreviewText'
import CheckboxGroupView from './CheckboxGroupView.vue'
import CheckboxView from './CheckboxView.vue'
import './style.scss'

const CheckboxGroupBase = defineComponent({
  name: 'CheckboxGroup',
  props: {
    options: {
      type: Array,
      default: () => ([])
    }
  },
  setup (props, { attrs, slots, listeners }) {
    return () => {
      const { options = [] } = props
      return h(
        CheckboxGroupView,
        {
          props: { options },
          attrs: {
            ...attrs
          },
          on: listeners
        },
        []
      )
    }
  }
})

const CheckboxGroup = connect(
  CheckboxGroupBase,
  mapProps({ dataSource: 'options' }),
  mapReadPretty(SelectPreviewText)
)

const CheckboxOption = defineComponent({
  name: 'Checkbox',
  inheritAttrs: false,
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  setup (props, { attrs, slots, listeners }) {
    return () => {
      const {option} = props || {}
      return h(
        CheckboxView,
        {
          props: { option },
          attrs: {
            ...attrs
          },
          on: listeners
        },
        []
      )
    }
  }
})

export {
  CheckboxView,
  CheckboxGroupView
}

export const Checkbox = composeExport(connect(CheckboxOption), {
  Group: CheckboxGroup
})

export default Checkbox
